import '../App.css';
const Header = () => {
	return <div className='header'>TYPING TEST</div>;
};
export default Header;
